import { render, staticRenderFns } from "./toBack.vue?vue&type=template&id=7b29eedf&"
import script from "./toBack.vue?vue&type=script&lang=ts&"
export * from "./toBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports